<div class="m-1x mb-3x mt-3x">

  <div *ngIf="!isKapGAus">
    <common-ui-laufende-nummer [(data)]="data" [readonly]="readonly"></common-ui-laufende-nummer>
  </div>

  <div class="form-row mb-3x">
    <label class="col-sm-8"
           for="personenTyp">{{ 'COMMON_UI.FRAGEBOGEN.ANTEILSEIGNER.PERSONENTYP_TITEL' | translate }}</label>
    <div class="col-sm-4">
      <select (change)="onPersonTypeChange()" [(ngModel)]="data.personenTyp" [disabled]="readonly" class="form-control"
              id="personenTyp">
        <option [ngValue]="undefined"
                selected>{{ 'COMMON_UI.FRAGEBOGEN.ANTEILSEIGNER.PERSONENTYP.NULL' | translate }}</option>
        <option *ngFor="let value of enumKeys(personenTypEnum)"
                [ngValue]="personenTypEnum[value]">
          {{ 'COMMON_UI.FRAGEBOGEN.ANTEILSEIGNER.PERSONENTYP.KEY_' + personenTypEnum[value].toUpperCase() | translate }}
        </option>
      </select>
    </div>
  </div>

  <div *ngIf="data.personenTyp === personenTypEnum.NatPers" class="mb-5x">
    <h2
      class="mb-3x">{{ 'COMMON_UI.FRAGEBOGEN.ANTEILSEIGNER.NATUERLICHE_PERSON_TITEL' | translate }}
    </h2>
    <common-ui-personenstamm-daten
      (dataChange)="onDataChanged()" [(data)]="data.natuerlichePerson"
      [readonly]="readonly">
    </common-ui-personenstamm-daten>
  </div>

  <div *ngIf="data.personenTyp === personenTypEnum.NNatPers" class="mb-5x">
    <h2
      class="mb-3x">{{ 'COMMON_UI.FRAGEBOGEN.ANTEILSEIGNER.JURISTISCHE_PERSON_TITEL' | translate }}
    </h2>
    <common-ui-juristische-person
      (dataChange)="onDataChanged()" [(data)]="data.juristischePerson"
      [readonly]="readonly">
    </common-ui-juristische-person>
  </div>

  <div *ngIf="data.personenTyp">
    <div class="mb-5x">
      <h2 class="mb-3x">{{ 'COMMON_UI.FRAGEBOGEN.ADRESSE.ADRESSE_TITEL' | translate }}</h2>
      <common-ui-adresserfassung
        [(auslandsadresse)]="data.auslandsadresse"
        [(inlandsadresse)]="data.inlandsadresse"
        [readonly]="readonly"
        [stammdatenAuslandsAdresse]="stammdaten?.auslandsadressen?.array"
        [stammdatenInlandsadresse]="stammdaten?.inlandsadressen?.array"
        disablePostfachadresse="true">
      </common-ui-adresserfassung>
    </div>
    <div class="mb-5x">
      <h2
        class="mb-3x">{{ 'COMMON_UI.FRAGEBOGEN.ANTEILSEIGNER.WEITERE_ANGABEN_ANTEILSEIGNER' | translate }}
      </h2>
      <common-ui-person-extended-weitere-angaben
        [(data)]="data.weitereAngabenAnteilseigner"
        [enableWeitereAngabenJuristischePerson]="data.personenTyp === personenTypEnum.NNatPers"
        [readonly]="readonly">
      </common-ui-person-extended-weitere-angaben>
    </div>
    <div class="mb-5x">
      <common-ui-steuernummer [(data)]="data.steuernummer" [readonly]="readonly"></common-ui-steuernummer>
      <common-ui-wirtschafts-id [(data)]="data"
                                fieldName="wirtschaftsIdNummer"
                                [readonly]="readonly"></common-ui-wirtschafts-id>
    </div>
    <div class="mb-5x">
      <h2
        class="mb-3x">{{ 'COMMON_UI.FRAGEBOGEN.ANTEILSEIGNER.HOEHE_BETEILIGUNG_TITEL' | translate }}
      </h2>
      <common-ui-hoehe-der-beteiligung
        (dataChange)="onDataChanged()"
        [(data)]="data.hoeheDerBeteiligung"
        [readonly]="readonly">
      </common-ui-hoehe-der-beteiligung>
    </div>
  </div>
</div>
